<template>
  <div class="ggu-offer">
    <div class="nav">
      <router-link to="/offer" tag="span" class="active">offer龙虎榜</router-link>
      <router-link to="/"  tag="span">学员申请总结</router-link>
    </div>
    <offer-twenty v-if="isPast == '2020'"  @offerYear="getOfferYear"></offer-twenty>
    <offer-twentyone v-if="isPast == '2021'" @offerYear="getOfferYear"></offer-twentyone>
  </div>
</template>

<script>
const imgUrl = "http://www.gguconsulting.com/Public/img/";
import api from "@/api/offer";
import offerTwenty from "./offer_2020";
import offerTwentyone from "./offer_2021";
export default {
  components: {
    offerTwenty,
    offerTwentyone
  },
  data() {
    return {
      imgUrl,
      wxImg: "http://www.gguconsulting.com/try/sbm/Public/img/offer_share_.jpg",
      isPast:'2021',
    };
  },
  methods: {
    getOfferYear(index){
      this.isPast = index;
    }
  },
  created() {
    this.WXConfig.wxShowMenu("2021世毕盟八大龙虎榜","更好录取 有目共睹","http://www.gguconsulting.com/try/sbm/index.php/#/offer",this.wxImg);
  }
};
</script>

<style lang="less" scoped>
// .ggu-offer{
//   padding-top:20px;
// }

//nav
.nav {
  height:90px;
  border-bottom:1px solid #E6E6E6;

  span {
    font-size:32px;
    color:#192533;
    width:50%;
    text-align:center;
    line-height:90px;
    display: inline-block;
    font-weight:600;
  }
  .active {
    color: #2a62d1;
    position: relative;
  }
  .active:before{
    border-bottom: 5px solid #2a62d1;
    bottom: 0;
    content: "";
    display: inline-block;
    left: calc(50% - 25px);
    position: absolute;
    width: 50px;
  }
}
</style>